/* Hillstonemarket front-end: live cart drawer, quick-add, reveal, CRO overlays.
   Talks to the real Shopify Cart AJAX API (/cart.js, /cart/add.js, /cart/change.js). */
(function () {
  var DATA = window.HM_DATA || {};
  var FMT = DATA.moneyFormat || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100);
    function withComma(n, dec) {
      var p = (Math.abs(n)).toFixed(dec).split('.');
      var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return (n < 0 ? '-' : '') + i + (p[1] ? '.' + p[1] : '');
    }
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withComma(value, 2);
        case 'amount_no_decimals': return withComma(value, 0);
        case 'amount_with_comma_separator': return withComma(value, 2).replace(/,/g, '@').replace(/\./g, ',').replace(/@/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withComma(value, 0).replace(/,/g, '@').replace(/\./g, ',').replace(/@/g, '.');
        default: return withComma(value, 2);
      }
    });
  }

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---------- cart drawer ---------- */
  var drawer = q('[data-hm-cart-drawer]');
  var backdrop = q('[data-hm-cart-backdrop]');
  var timerInt = null, timerLeft = 266;

  function openCart() {
    if (!drawer) { window.location.href = '/cart'; return; }
    renderCart();
    drawer.style.transform = 'translateX(0)';
    if (backdrop) { backdrop.style.opacity = '1'; backdrop.style.visibility = 'visible'; }
    timerLeft = 266; startTimer();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.style.transform = 'translateX(100%)';
    if (backdrop) { backdrop.style.opacity = '0'; backdrop.style.visibility = 'hidden'; }
    if (timerInt) clearInterval(timerInt);
  }
  function startTimer() {
    var el = q('[data-hm-timer]');
    if (timerInt) clearInterval(timerInt);
    timerInt = setInterval(function () {
      if (timerLeft > 0) timerLeft--;
      if (el) { var m = Math.floor(timerLeft / 60), s = timerLeft % 60; el.textContent = m + ':' + (s < 10 ? '0' + s : s); }
    }, 1000);
  }

  function swatch(seed) {
    var hue = ((seed || 0) * 47) % 360;
    return 'background:repeating-linear-gradient(135deg,oklch(0.9 0.05 ' + hue + ') 0 8px,oklch(0.84 0.07 ' + hue + ') 8px 16px)';
  }

 
  function lineRow(item) {
    var img = item.image
      ? '<div style="width:64px;height:64px;border-radius:12px;flex-shrink:0;background:url(' + item.image + ') center/cover"></div>'
      : '<div style="width:64px;height:64px;border-radius:12px;flex-shrink:0;' + swatch(item.product_id) + '"></div>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    return '<div style="display:flex;gap:12px;align-items:flex-start">' + img +
      '<div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:8px">' +
        '<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start">' +
          '<div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:2px">' +
            '<span style="font-weight:600;font-size:14px;color:#1A1A1A;line-height:1.3;word-break:break-word;overflow-wrap:anywhere">' + item.product_title + '</span>' +
            (variant ? '<span style="font-size:12px;color:#9A9488">' + variant + '</span>' : '') +
          '</div>' +
          '<span style="font-family:Sora,sans-serif;font-weight:700;font-size:14.5px;color:#1A1A1A;white-space:nowrap;flex-shrink:0">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<div style="display:flex;align-items:center;gap:10px">' +
          '<div style="display:flex;align-items:center;border:1px solid #E4DFD4;border-radius:9px;overflow:hidden;width:fit-content">' +
            '<button type="button" data-line="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease" style="background:#F7F5F0;border:none;cursor:pointer;width:30px;height:30px;font-size:16px;color:#1A1A1A">\u2212</button>' +
            '<span style="min-width:30px;text-align:center;font-size:13.5px;font-weight:600;font-variant-numeric:tabular-nums">' + item.quantity + '</span>' +
            '<button type="button" data-line="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase" style="background:#F7F5F0;border:none;cursor:pointer;width:30px;height:30px;font-size:16px;color:#1A1A1A">+</button>' +
          '</div>' +
          '<button type="button" data-line="' + item.key + '" data-qty="0" aria-label="Remove" style="background:none;border:none;cursor:pointer;color:#B8B2A6;font-size:13px;text-decoration:underline;padding:4px">Remove</button>' +
        '</div>' +
      '</div></div>';
  }

  function emptyState() {
    return '<div style="text-align:center;padding:48px 20px;display:flex;flex-direction:column;align-items:center;gap:14px">' +
      '<span style="font-size:46px;opacity:.5">🛒</span>' +
      '<span style="font-family:Sora,sans-serif;font-weight:600;font-size:17px;color:#1A1A1A">Your cart is empty</span>' +
      '<span style="font-size:13.5px;color:#9A9488;max-width:220px">Browse our categories and find something you\'ll love.</span>' +
      '<a href="' + (DATA.shopUrl || '/collections/all') + '" style="margin-top:6px;padding:12px 22px;background:#1E5145;color:#fff;text-decoration:none;border-radius:12px;font-weight:600;font-size:14px">Start Shopping</a></div>';
  }

  function renderCart() {
    getCart().then(function (cart) {
      var body = q('[data-hm-cart-body]'), footer = q('[data-hm-cart-footer]');
      var countEl = q('[data-hm-cart-count]'); if (countEl) countEl.textContent = '(' + cart.item_count + ')';
      qa('[data-hm-header-count]').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; });
      if (!body) return;
      if (!cart.items.length) { body.innerHTML = emptyState(); if (footer) footer.style.display = 'none'; return; }
      var html = '<div style="display:flex;flex-direction:column;gap:14px">';
      cart.items.forEach(function (it) { html += lineRow(it); });
      html += '</div>';
      body.innerHTML = html;
      if (footer) footer.style.display = 'flex';
      var cscope = drawer || document;
      var sub = q('[data-hm-subtotal]', cscope); if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
      var tot = q('[data-hm-total]', cscope); if (tot) tot.textContent = formatMoney(cart.total_price);
      var co = q('[data-hm-checkout]', cscope); if (co) co.textContent = 'Checkout · ' + formatMoney(cart.total_price);
      // shipping protection row
      var prow = q('[data-hm-protect-row]', cscope);
      if (prow && DATA.protectVariantId) {
        prow.hidden = false;
        var feeEl = q('[data-hm-protect-fee]', cscope); if (feeEl && DATA.protectPrice != null) feeEl.textContent = '+' + formatMoney(DATA.protectPrice);
        var on = cart.items.some(function (i) { return String(i.variant_id) === String(DATA.protectVariantId); });
        var tog = q('[data-hm-protect-toggle]', cscope), knob = q('[data-hm-protect-knob]', cscope);
        if (tog) { tog.setAttribute('aria-checked', on ? 'true' : 'false'); tog.style.background = on ? '#1E5145' : '#CFC9BD'; }
        if (knob) knob.style.transform = on ? 'translateX(18px)' : 'translateX(0)';
      }
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(id, qty, cb) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { if (cb) cb(); openCart(); })
      .catch(function () { window.location.href = '/cart'; });
  }
  window.HMAddToCart = addToCart;
  window.HMOpenCart = openCart;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-hm-cart-close]')) { closeCart(); return; }
    if (t === backdrop) { closeCart(); return; }
    if (t.closest('[data-hm-open-cart]')) { e.preventDefault(); openCart(); return; }
    var qa1 = t.closest('.hm-quick-add[data-add-id]');
    if (qa1) {
      e.preventDefault(); e.stopPropagation();
      var btn = qa1, label = btn.textContent;
      addToCart(btn.getAttribute('data-add-id'), 1, function () {
        btn.textContent = 'Added ✓'; btn.style.background = '#2E7D52';
        setTimeout(function () { btn.textContent = label; btn.style.background = '#1E5145'; }, 1300);
      });
      return;
    }
    var ln = t.closest('[data-line]');
    if (ln) { e.preventDefault(); changeLine(ln.getAttribute('data-line'), parseInt(ln.getAttribute('data-qty'), 10)); return; }
    var pt = t.closest('[data-hm-protect-toggle]');
    if (pt && DATA.protectVariantId) {
      e.preventDefault();
      var on = pt.getAttribute('aria-checked') === 'true';
      if (on) {
        getCart().then(function (cart) {
          var line = cart.items.filter(function (i) { return String(i.variant_id) === String(DATA.protectVariantId); })[0];
          if (line) changeLine(line.key, 0);
        });
      } else { addToCart(DATA.protectVariantId, 1); }
      return;
    }
  });

  window.addEventListener('hm:open-cart', openCart);

  /* ---------- reveal animations ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) { qa('[data-reveal]').forEach(function (el) { el.style.opacity = '1'; }); return; }
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.animation = 'hm-fadeup .6s ease both'; ro.unobserve(e.target); } });
    }, { threshold: .12 });
    setTimeout(function () { qa('[data-reveal]').forEach(function (el) { el.style.opacity = '0'; ro.observe(el); }); }, 60);
    setTimeout(function () { qa('[data-reveal]').forEach(function (el) { el.style.opacity = '1'; }); }, 1800);
  }

  /* ---------- count-up stats ---------- */
  function initCounters() {
    qa('[data-countup]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-countup')), dec = parseInt(el.getAttribute('data-dec') || '0', 10), suffix = el.getAttribute('data-suffix') || '';
      var done = false;
      function run() {
        if (done) return; done = true;
        var t0 = performance.now(), dur = 1400;
        (function tick(t) {
          var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3), v = target * e;
          el.textContent = (dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-US')) + suffix;
          if (p < 1) requestAnimationFrame(tick); else el.textContent = (dec ? target.toFixed(dec) : Math.round(target).toLocaleString('en-US')) + suffix;
        })(t0);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { run(); io.disconnect(); } }); }, { threshold: .3 });
        io.observe(el);
        setTimeout(run, 1800);
      } else run();
    });
  }

  /* ---------- recent order toast ---------- */
  function initToast() {
    var toast = q('[data-hm-toast]'); if (!toast) return;
    var names = ['Emma R.','Liam K.','Sofia M.','Noah B.','Ava T.','Mateo G.','Olivia P.','Lucas H.','Mia D.','Ethan W.','Chloe S.','Leo F.','Zoe A.','Henry C.','Nora V.'];
    var cities = ['Austin, TX','Lyon, FR','Berlin, DE','Madrid, ES','Toronto, CA','Denver, CO','Manchester, UK','Sydney, AU','Portland, OR'];
    var products = (DATA.products && DATA.products.length) ? DATA.products : ['a best-seller'];
    var hideT;
    function show() {
      q('[data-hm-toast-name]').textContent = names[Math.floor(Math.random() * names.length)];
      q('[data-hm-toast-city]').textContent = cities[Math.floor(Math.random() * cities.length)];
      q('[data-hm-toast-product]').textContent = products[Math.floor(Math.random() * products.length)];
      q('[data-hm-toast-ago]').textContent = 1 + Math.floor(Math.random() * 9);
      toast.style.transform = 'translateY(0)'; toast.style.opacity = '1'; toast.style.pointerEvents = 'auto';
      clearTimeout(hideT); hideT = setTimeout(hide, 5000);
    }
    function hide() { toast.style.transform = 'translateY(140%)'; toast.style.opacity = '0'; toast.style.pointerEvents = 'none'; }
    var dismiss = q('[data-hm-toast-dismiss]'); if (dismiss) dismiss.addEventListener('click', hide);
    function schedule() { setTimeout(function () { show(); schedule(); }, 9000 + Math.random() * 8000); }
    setTimeout(function () { show(); schedule(); }, 5000);
  }

  /* ---------- exit intent ---------- */
  function initExit() {
    var bd = q('[data-hm-exit-backdrop]'); if (!bd) return;
    var done = sessionStorage.getItem('hm_exit_shown') === '1';
    function trigger() {
      if (done) return; done = true; sessionStorage.setItem('hm_exit_shown', '1');
      bd.style.opacity = '1'; bd.style.visibility = 'visible';
      var modal = q('[data-hm-exit-modal]'); if (modal) modal.style.transform = 'scale(1)';
    }
    function close() {
      bd.style.opacity = '0'; bd.style.visibility = 'hidden';
      var modal = q('[data-hm-exit-modal]'); if (modal) modal.style.transform = 'scale(.9)';
    }
    document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) trigger(); });
    setTimeout(function () { if (!done) trigger(); }, 40000);
    qa('[data-hm-exit-close]').forEach(function (b) { b.addEventListener('click', close); });
    bd.addEventListener('click', function (e) { if (e.target === bd) close(); });
    var form = q('[data-hm-exit-submit]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = q('[data-hm-exit-form]'), d = q('[data-hm-exit-done]');
      if (f) f.hidden = true; if (d) d.hidden = false;
    });
  }

  function init() { renderCart(); initReveal(); initCounters(); initToast(); initExit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
